import React from 'react';
import { Dialog } from '@material-ui/core';
import { Button, ButtonGroup } from 'reactstrap';
import Draggable from 'react-draggable';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';

const defaultEmpVideoSrc = '/empImg/video_imge.png';

function PaperComponent(props) {


  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function YangsicDetail(props) {
  const styleDialogTitle = {
    position: 'absolute',
    color: 'white',
    fontSize: '0.85rem',
    margin: 0,
    right: '0',
    float: 'center',
    zIndex: '10', //z-index 겹침부분인덱스 기본갑은 0 이다
  };

  const errorHandle = (event) => {
    // console.log(event.target.error.message)
    alert(event.target.error.message)
  }

  return (
    <div className="bothsize">
      <Dialog
        open={props.yangsicDetailTrue}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={styleDialogTitle}>
          <ButtonGroup id="draggable-dialog-title" size="small">
            <Button color="danger" outline style={{ cursor: 'move', marginRight: '2px' }} size="small">
              이동
            </Button>
          </ButtonGroup>
          <Button color="danger" outline style={{ zIndex: '20' }} onClick={() => { props.setYangsicDetailTrue(false) }} size="small">
            닫기
          </Button>
        </DialogTitle>
        <video
          style={{ margin: 'auto', verticalAlign: 'baseline' }}
          poster={defaultEmpVideoSrc}
          controls
          preload="auto"
          // autoPlay
          // playstart='flase'
          width="100%"
          height="auto"
          data-setup="{}"
          onError={errorHandle}
        >
          <source src={props.yangsicValue} />
          <p>이 브라우즈는 Video 요가가 지원하지 않습니다.</p>
        </video>
      </Dialog>
    </div>
  );
}

export default YangsicDetail;
